// CANONICAL COPY (GH #7115). src/constants/obligations/obl-audit-testing-protection.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-audit-testing-protection',
  title: 'Plan and authorise audit / security validation testing',
  description:
    'Confirm that requirements and activities involving audit, security validation and verification testing of operational systems are planned and agreed with system owners to minimise disruption to business processes. Penetration tests, vulnerability scans and control-effectiveness validations shall have scope, rules of engagement, change windows and approval recorded before execution.',
  category: 'compliance',
  scfIds: ['SCF-DEV-010'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Audit / testing protection procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
